export var MuiListSubheader = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                paddingLeft: 0,
                paddingRight: 0,
                fontWeight: 500,
                fontSize: 15,
                color: theme.palette.grey[800],
            });
        },
    },
};
